/* DentalPets PDP V2 — LAB-ONLY behaviour.
   Loaded only on templates/product.dentalpets-v2-lab.json. Adds nothing global: every listener is
   bound to a [data-dp-qit] root or to [data-dp-sticky-atc], both of which exist on the lab
   template only, so no other PDP component is affected.
   assets/dp-pdp-v2.js is not modified. No external library.

   1. Quick info tabs (.dp-qit)
   2. Sticky Add to cart delegation (see initStickyAtc) */
(function () {
  'use strict';

  function headerOffset() {
    var header = document.querySelector('.m-header.m\\:sticky-element, .m-header[data-sticky="on_scroll_up"], .m-header[data-sticky="always"]');
    if (!header) return 0;
    var box = header.getBoundingClientRect();
    return box.height < 200 && getComputedStyle(header).position === 'sticky' ? box.height : 0;
  }

  function initTabs(root) {
    if (!root || root.dataset.dpQitReady === '1') return;
    var list = root.querySelector('[role="tablist"]');
    if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    root.dataset.dpQitReady = '1';

    function panelFor(tab) {
      var id = tab.getAttribute('aria-controls');
      return id ? root.querySelector('#' + CSS.escape(id)) : null;
    }

    function select(tab, focusTab) {
      tabs.forEach(function (other) {
        var isCurrent = other === tab;
        other.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        other.setAttribute('tabindex', isCurrent ? '0' : '-1');
        other.classList.toggle('is-active', isCurrent);
        var panel = panelFor(other);
        if (panel) {
          panel.hidden = !isCurrent;
          panel.classList.toggle('is-active', isCurrent);
        }
      });
      if (focusTab) {
        tab.focus();
        if (tab.scrollIntoView) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab, false); });
    });

    list.addEventListener('keydown', function (event) {
      var index = tabs.indexOf(document.activeElement);
      if (index === -1) return;
      var next = null;
      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = tabs[(index + 1) % tabs.length];
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = tabs[(index - 1 + tabs.length) % tabs.length];
          break;
        case 'Home':
          next = tabs[0];
          break;
        case 'End':
          next = tabs[tabs.length - 1];
          break;
        default:
          return;
      }
      event.preventDefault();
      select(next, true);
    });

    /* In-page jumps to the full Ingredients / How to use sections.
       Template sections are wrapped in #shopify-section-template--<id>__<name>, which is not
       predictable from here, so the target is addressed by its own data-section-type instead. */
    root.addEventListener('click', function (event) {
      var jump = event.target.closest && event.target.closest('[data-dp-qit-jump]');
      if (!jump) return;
      var selector = jump.getAttribute('data-dp-target');
      if (!selector) return;
      var target = null;
      try { target = document.querySelector(selector); } catch (e) { return; }
      if (!target) return;
      event.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    });
  }


  /* ============================================================
     Sticky Add to cart — delegate to the primary Add to cart button
     ============================================================
     The sticky bar owns no cart logic of its own. It finds the main product form's own submit
     button ([name="add"] inside .m-product-form--main) and clicks it, which is byte-for-byte the
     same code path as a customer tapping ADD TO CART: Minimog's <product-form> submit handler
     serialises that form, and Kaching has already written the selected bundle into it
     (quantity + properties[__kaching_bundles]). So the currently selected 1/2/3-tub offer, its
     discount and the cart-drawer feedback all come from the existing flow untouched.

     Explicitly NOT done here: no /cart/add request, no quantity or price maths, no reading or
     rewriting of Kaching state, no scrolling, no second form. */

  function mainAtcButton() {
    var form = document.querySelector('.m-main-product--info .m-product-form--main')
            || document.querySelector('.m-product-form--main');
    if (!form) return null;
    // Never target a sticky-atc clone: only the button inside the main product form.
    return form.querySelector('button[name="add"], [type="submit"][name="add"]');
  }

  function atcBusy(btn) {
    var host = btn.closest('product-form') || btn.parentElement;
    return btn.disabled
        || btn.getAttribute('aria-disabled') === 'true'
        || btn.classList.contains('m-spinner-loading')
        || !!(host && host.classList.contains('m-spinner-loading'));
  }

  function initStickyAtc(root) {
    var bar = root || document.querySelector('.dp-sticky--lab');
    if (!bar || bar.dataset.dpStickyReady === '1') return;
    var proxy = bar.querySelector('[data-dp-sticky-atc]');
    if (!proxy) return;
    bar.dataset.dpStickyReady = '1';

    var labelEl = proxy.querySelector('[data-dp-sticky-label]');
    var idleLabel = labelEl ? labelEl.textContent : '';
    var busyLabel = proxy.getAttribute('data-dp-busy-label') || idleLabel;
    var lockedUntil = 0;

    function setBusy(on) {
      proxy.classList.toggle('is-busy', on);
      proxy.setAttribute('aria-busy', on ? 'true' : 'false');
      if (labelEl && busyLabel) labelEl.textContent = on ? busyLabel : idleLabel;
    }

    /* Mirror the primary button's sold-out / unavailable state so the sticky can never offer an
       add that the main button is refusing. */
    var main = mainAtcButton();
    if (main && window.MutationObserver) {
      var mirror = function () {
        var off = main.disabled || main.getAttribute('aria-disabled') === 'true';
        proxy.disabled = !!off;
        proxy.setAttribute('aria-disabled', off ? 'true' : 'false');
      };
      mirror();
      new MutationObserver(mirror).observe(main, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    proxy.addEventListener('click', function (event) {
      event.preventDefault();
      var now = Date.now();
      if (now < lockedUntil) return;              // guard against a double tap
      var target = mainAtcButton();               // re-query: section reloads swap the node
      if (!target || target.disabled) return;
      if (atcBusy(target)) return;                // an add is already in flight
      lockedUntil = now + 900;
      setBusy(true);
      target.click();                             // the one and only add-to-cart path
      window.setTimeout(function () { setBusy(false); }, 900);
    });
  }

  function initAll(scope) {
    var host = scope || document;
    host.querySelectorAll('[data-dp-qit]').forEach(initTabs);
    host.querySelectorAll('.dp-sticky--lab').forEach(function (bar) { initStickyAtc(bar); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: (re)initialise a reloaded section only */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
